import {Link} from "react-router-dom";
import * as React from "react";

interface IProps {
    policyNumber: string;
    showPolicyNumber: boolean;
}

export class RefundPaymentDetailsUpdateBanner extends React.Component<IProps> {


    public render() {
        const pathName = `/dashboard/${this.props.policyNumber}/refundDetails/editDirectDebit/`

        return (
            <div className="inner-cogntainer">
                <div className="warning-banner dashboard-failed-refund-banner mb-0">
                    <div className="w-100">
                        <div className="overflow-auto d-flex">
                            <div className="banner-text inline-warning-text">
                                You’re due a refund{this.props.showPolicyNumber ? ` for ${this.props.policyNumber}` : ""}. Please set-up a Direct Debit so we can process this refund for you.
                                <div>
                                    <Link id="setupRefund" className="d-inline text-decoration-underline cursor-pointer muli-bold-16"
                                          aria-label={"Set-up refund"}
                                          state={{policyNumber: this.props.policyNumber}}
                                          to={pathName}>
                                        Set-up your Direct Debit</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
